document.addEventListener("DOMContentLoaded", function() {
  initLightbox();
});

function initLightbox() {
  const contents = document.querySelectorAll(".wiki-layout-main-d5");
  
  contents.forEach(content => {
    const mediaContainer = content.querySelector(".tb-media-d5");
    if (!mediaContainer) return;
    
    const mediaElements = content.querySelectorAll(".wm-main-d5 img, .wm-main-d5 video");
    const mediaData = [];
    
    mediaElements.forEach((media, index) => {
      media.id = media.id || `media-${index}`;
      
      const clone = media.cloneNode(true);
      const infoElement = content.querySelector(`.media-info-text-d5#${media.id}`);
      
      mediaData.push({
        id: media.id,
        element: clone,
        infoElement: infoElement ? infoElement.cloneNode(true) : null
      });
      
      mediaContainer.appendChild(clone);
      
      media.addEventListener("click", () => {
        openLightbox(mediaData, media.id);
      });
      
      clone.addEventListener("click", () => {
        openLightbox(mediaData, media.id);
      });
    });
  });
  
 function openLightbox(mediaData, currentId) {
    const lightbox = document.createElement("div");
    lightbox.className = "lightbox-d5";
    lightbox.innerHTML = `
      <div class="lightbox-content-d5">
        <button class="lightbox-close-d5">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
        </svg>
        </button>
        <button class="lightbox-nav lightbox-prev-d5">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M9.29 6.71a1 1 0 0 1 1.42 0l5 5a1 1 0 0 1 0 1.42l-5 5a1 1 0 1 1-1.42-1.42L13.59 12 9.29 8.12a1 1 0 0 1 0-1.41z"/>
          </svg>

        </button>
        <button class="lightbox-nav lightbox-next-d5">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M9.29 6.71a1 1 0 0 1 1.42 0l5 5a1 1 0 0 1 0 1.42l-5 5a1 1 0 1 1-1.42-1.42L13.59 12 9.29 8.12a1 1 0 0 1 0-1.41z"/>
          </svg>
        </button>
        <div class="lightbox-main-d5"></div>
        <div class="lightbox-sidebar-d5">
          <div class="lightbox-info-d5"></div>
          <div class="lightbox-thumbs-d5"></div>
        </div>
      </div>
    `;
    
    document.body.appendChild(lightbox);
    document.body.style.overflow = "hidden";
    
    const mainArea = lightbox.querySelector(".lightbox-main-d5");
    const sidebar = lightbox.querySelector(".lightbox-sidebar-d5");
    const thumbsArea = lightbox.querySelector(".lightbox-thumbs-d5");
    const infoArea = lightbox.querySelector(".lightbox-info-d5");
    const closeBtn = lightbox.querySelector(".lightbox-close-d5");
    const prevBtn = lightbox.querySelector(".lightbox-prev-d5");
    const nextBtn = lightbox.querySelector(".lightbox-next-d5");
    
    let currentIndex = mediaData.findIndex(item => item.id === currentId);
    if (currentIndex === -1) currentIndex = 0;
    
    function showMedia(index) {
      const media = mediaData[index];
      mainArea.innerHTML = "";
      mainArea.appendChild(media.element.cloneNode(true));
      
      infoArea.innerHTML = "";
      if (media.infoElement) {
        infoArea.appendChild(media.infoElement.cloneNode(true));
      }
      
      thumbsArea.querySelectorAll(".sidebar-item-d5").forEach(item => {
        item.classList.remove("active");
      });
      
      const activeItem = thumbsArea.querySelector(`[data-id="${media.id}"]`);
      if (activeItem) activeItem.classList.add("active");
      
      currentIndex = index;
      
      // Update button states
      // prevBtn.style.display = mediaData.length > 1 ? "block" : "none";
      // nextBtn.style.display = mediaData.length > 1 ? "block" : "none";
    }
    
    function navigate(direction) {
      let newIndex = currentIndex + direction;
      if (newIndex < 0) newIndex = mediaData.length - 1;
      if (newIndex >= mediaData.length) newIndex = 0;
      showMedia(newIndex);
    }
    
    mediaData.forEach((media, index) => {
      const thumb = document.createElement("div");
      thumb.className = "sidebar-item-d5";
      thumb.dataset.id = media.id;
      
      const thumbMedia = media.element.cloneNode(true);
      thumb.appendChild(thumbMedia);
      
      thumb.addEventListener("click", () => {
        showMedia(index);
      });
      
      thumbsArea.appendChild(thumb);
    });
    
    function handleKeydown(e) {
      if (e.key === "Escape") {
        closeLightbox();
      } else if (e.key === "ArrowLeft") {
        navigate(-1);
      } else if (e.key === "ArrowRight") {
        navigate(1);
      }
    }
    
    function closeLightbox() {
      document.removeEventListener("keydown", handleKeydown);
      document.body.style.overflow = "";
      document.body.removeChild(lightbox);
    }
    
    closeBtn.addEventListener("click", closeLightbox);
    prevBtn.addEventListener("click", () => navigate(-1));
    nextBtn.addEventListener("click", () => navigate(1));
    
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    });
    
    document.addEventListener("keydown", handleKeydown);
    
    showMedia(currentIndex);
  }
}